import { render, staticRenderFns } from "./PosErrorModal.vue?vue&type=template&id=f838c552"
import script from "./PosErrorModal.vue?vue&type=script&lang=js"
export * from "./PosErrorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports